import { Component, OnInit, Input } from '@angular/core';
import { AutoPlanDownloadsService } from '../auto-plan-downloads.service';

@Component({
    selector: 'sc-auto-plan-downloads',
    templateUrl: './auto-plan-downloads.component.html',
    styleUrls: ['./auto-plan-downloads.component.scss']
})

export class AutoPlanDownloadsComponent implements OnInit {

    selectedDownloadItems = [];
    waitForPolicyWithClauses = false;
    waitForPolicyWithoutClauses = false;
    waitForCertificate = false;
    waitForMandatoryInsurance = false;
    waitForCoupons = false;
    waitForMercosur = false;
    waitForReceiptPayment = false;
    waitForProposal = false;
    waitForPolicyChange = false;
    @Input() policyData = {
        policyNumber: ''
    };

    constructor(private _downloadService: AutoPlanDownloadsService) {}

    ngOnInit() {}

    selectDownloadItem(item: any) {
        const _index = this.selectedDownloadItems.indexOf(item.id);
        if (_index > -1) {
            this.selectedDownloadItems.splice(_index, 1);
        } else {
            this.selectedDownloadItems.push(item.id);
            this.downloadReports(item.id, item);
        }

        item['selected'] = !item['selected'];
    }

    downloadReports(type, item) {
        switch (type) {

            case 'liPoliza':
                this.getDownloadPolicyAction(item);
                break;

            case 'liPolicyWithClauses':
                this.getDownloadPolicyWithClauses(item);
                break;

            case 'liTarjetaObligatoria':
                this.getDownloadMandatoryInsuranceAction(item);
                break;

            case 'liMercosur':
                this.getDownloadMercosurAction(item);
                break;

            case 'liCupones':
                this.getDownloadProofOfPaymentAction(item);
                break;
            case 'liPolicyChange':
                this.getDownloadPolicyChangeRePrint(item);

        }
    }

    getDownloadMandatoryInsuranceAction(item) {
        this.waitForMandatoryInsurance = true;
        return this._downloadService.downloadMandatoryInsurance(
            this.getBranchOfficeFromPolicyNumber(),
            this.getBranchFromPolicyNumber(),
            this.getPolicyNumber()
        ).subscribe(response => {
            this.waitForMandatoryInsurance = false;
        }, error => {
            this.onHandleErrorDownload(item);
            this.waitForMandatoryInsurance = false;
        });
    }

    getDownloadPolicyAction(item) {
        this.waitForPolicyWithoutClauses = true;

        return this._downloadService.downloadPolicy(
            this.getBranchOfficeFromPolicyNumber(),
            this.getBranchFromPolicyNumber(),
            this.getPolicyNumber()
        ).subscribe(response => {
            this.waitForPolicyWithoutClauses = false;
        }, error => {
            console.error(error);
            this.onHandleErrorDownload(item);
            this.waitForPolicyWithoutClauses = false;
        });
    }

    getDownloadMercosurAction(item) {
        this.waitForMercosur = true;
        return this._downloadService.downloadMercosur(
            this.getBranchOfficeFromPolicyNumber(),
            this.getBranchFromPolicyNumber(),
            this.getPolicyNumber()
        ).subscribe(response => {
            this.waitForMercosur = false;
        }, error => {
            this.onHandleErrorDownload(item);
            this.waitForMercosur = false;
        });
    }


    getDownloadCouponsAction(item) {
        this.waitForCoupons = true;
        return this._downloadService.downloadCoupons(
            this.getBranchOfficeFromPolicyNumber(),
            this.getBranchFromPolicyNumber(),
            this.getPolicyNumber()
        ).subscribe(response => {
            this.waitForCoupons = false;
        }, error => {
            this.onHandleErrorDownload(item);
            this.waitForCoupons = false;
        });
    }

    getDownloadProofOfPaymentAction(item) {
        this.waitForReceiptPayment = true;
        return this._downloadService.downloadProofOfPayment(
            this.getBranchOfficeFromPolicyNumber(),
            this.getBranchFromPolicyNumber(),
            this.getPolicyNumber()
        ).subscribe(response => {
            this.waitForReceiptPayment = false;
        }, error => {
            this.onHandleErrorDownload(item);
            this.waitForReceiptPayment = false;
        });
    }

    getDownloadPolicyWithClauses(item) {
        this.waitForPolicyWithClauses = true;
        return this._downloadService.downloadPolicyWithClauses(
            this.getBranchOfficeFromPolicyNumber(),
            this.getBranchFromPolicyNumber(),
            this.getPolicyNumber()
        ).subscribe(response => {
            this.waitForPolicyWithClauses = false;
        }, error => {
            this.onHandleErrorDownload(item);
            this.waitForPolicyWithClauses = false;
        });
    }

    getDownloadPolicyChangeRePrint(item) {
        this.waitForPolicyChange = true;
        return this._downloadService.downloadPolicyChangeRePrint(this.policyData.policyNumber
        ).subscribe(() => {
            this.waitForPolicyChange = false;
        }, error => {
            this.onHandleErrorDownload(item);
            this.waitForPolicyChange = false;
        });
    }

    /**
    * Devuelve porción del ramo del número de póliza completo
    */
    getBranchOfficeFromPolicyNumber() {
        return String(parseInt(this.policyData.policyNumber.split('-')[1]));
    }

    /**
    * Devuelve porción del ramo del número de póliza completo
    */
    getBranchFromPolicyNumber() {
        return String(parseInt(this.policyData.policyNumber.split('-')[2]));
    }

    /**
    * Devuelve porción del número de póliza sin casa, ramo, etc
    */
    getPolicyNumber() {
        return this.policyData.policyNumber.split('-')[3];
    }

    onHandleErrorDownload(item) {
        item['selected'] = false;

        const _index = this.selectedDownloadItems.indexOf(item.id);
        if (_index > -1) {
            this.selectedDownloadItems.splice(_index, 1);
        }
    }
    
}
